import { InspectionStandardDTO } from "../../../common/types/common.dto.types";
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";

// ==============================|| VIEWS - COMPONENTS - VIEW INSPECTION SUMMARY - API ||============================== //

// client object for axios calls to backend
const client = new ApiClient();

export const getSummaryOfInspection = async (
  inspectionStandard: InspectionStandardDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `InspectionQuestion/GetSummaryOfInspection`;
    let inspectionstandardSumerySummery = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, inspectionStandard)
      .then((response: ActionResponseType) => {
        inspectionstandardSumerySummery = response;
      })
      .catch((error) => {
        inspectionstandardSumerySummery = {} as ActionResponseType;
      });
    return inspectionstandardSumerySummery;
  } catch (error) {
    throw error;
  }
};
